import React, { useState, useEffect, useContext } from 'react';
import { PropTypes } from 'prop-types';
import add from '../../../assets/images/add_image.svg';
import useStorage from '../../../hooks/useStorage';
import { deleteReportImage } from '../../../redux/Reports/ReportsAction';
import { useDispatch } from 'react-redux';
import dataUrlToBlob from '../../../utils/dataUrlToBlob';
import ImageEditor from '../../UI/views/ImageEditor';
import ImageShow from '../../UI/views/ImageShow';
import useCheckMobileScreen from '../../../hooks/useWidth';
import AddFab from '../../Laboratory/AddFab';
import styles from './picture.styles';
import MessagesContext from '../../../contexts/messagesContext';

const Picture = ({
    imagesFiles,
    setImageFiles,
    reportId,
    showMode,
    isAddRadiology,
    isRadiology
}) => {
    const isMobile = useCheckMobileScreen();
    const classes = styles({ showMode, isAddRadiology });
    const { messages } = useContext(MessagesContext);
    const dispatch = useDispatch();
    const [info, setInfo] = useState({
        images: imagesFiles,
        newImages: []
    });
    useEffect(() => {
        setInfo((state) => ({ ...state, images: [...imagesFiles] }));
    }, [reportId, imagesFiles]);

    useEffect(() => {
        !showMode && setImageFiles(info.newImages);
    }, [info.newImages, info.images]);

    const [modal, setModal] = useState({
        visible: false,
        image: null
    });
    const handleModal = (image) => () => {
        setModal({
            visible: true,
            image
        });
    };
    const handleModalDismiss = () => {
        setModal({
            visible: false
        });
    };
    const handleDeleteImage = (id) => async () => {
        handleModalDismiss();
        if (`${id}`.includes('new')) {
            setInfo((state) => ({
                images: state.images.filter((v) => v.id !== id),
                newImages: state.newImages.filter((v) => v.id !== id)
            }));
        } else {
            const response = await dispatch(deleteReportImage(reportId, id));
            if (response.status === 200) {
                setInfo((state) => ({ ...state, images: [...response.data.images] }));
                handleModalDismiss();
            } else {
                handleModalDismiss();
            }
        }
    };
    const handleEditImage = (image) => (dataUrl) => {
        const imageFile = dataUrlToBlob(dataUrl, `synapps${image.id}`);
        const newImages = info.newImages.map((v) =>
            v.id === image.id ? { id: image.id, file: imageFile } : v
        );
        const images = info.images.map((v) =>
            v.id === image.id ? { id: image.id, url: dataUrl } : v
        );
        setInfo((state) => ({
            ...state,
            images,
            newImages
        }));
    };
    const { selectFile } = useStorage({
        limit: 2,
        accept: 'Image/*',
        onRead: (dataUrls) => {
            setInfo((state) => ({
                ...state,
                images: [
                    {
                        url: dataUrls[0],
                        id: `new${state.images.filter((v) => `${v.id}`.includes('new')).length}`
                    },
                    ...state.images
                ]
            }));
        },
        onChange: (files) => {
            setInfo((state) => ({
                ...state,
                newImages: [
                    { file: files[0], id: `new${state.newImages.length}` },
                    ...state.newImages
                ]
            }));
        }
    });
    return (
        <>
            <div className={classes.form__images}>
                {isMobile && isAddRadiology && (
                    <div className={classes.title}>{messages.images}</div>
                )}
                {info.images?.map((image) => (
                    <ImageEditor
                        key={`${image.id}`}
                        classes={classes}
                        onClick={handleModal(image)}
                        src={image.url}
                        className={classes.image__container}
                        onImageEdited={handleEditImage(image)}
                        disableEditing={!`${image.id}`.includes('new')}
                        handleDelete={handleDeleteImage(image.id)}
                        isAddRadiology={isAddRadiology}
                        isRadiology={isRadiology}
                    />
                ))}
                {!showMode && (
                    <div
                        onClick={selectFile}
                        className={!isMobile && classes.form__add__image__container}
                    >
                        {isMobile ? (
                            <AddFab bottom={0} right={'-6px'} />
                        ) : (
                            <div className={classes.form__add__image}>
                                <img className={classes.add__image} src={add} />
                            </div>
                        )}
                    </div>
                )}
            </div>

            <ImageShow
                src={modal.image?.url}
                visible={modal.visible}
                handleDelete={handleDeleteImage(modal.image?.id)}
                handleDismiss={handleModalDismiss}
            />
        </>
    );
};
Picture.propTypes = {
    setImageFiles: PropTypes.func,
    reportId: PropTypes.any,
    showMode: PropTypes.any,
    imagesFiles: PropTypes.any,
    isAddRadiology: PropTypes.bool,
    isRadiology: PropTypes.bool
};
export default Picture;
